var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCompare = function SvgCompare(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 21H5q-.824 0-1.412-.587A1.93 1.93 0 0 1 3 19V5q0-.824.587-1.412A1.93 1.93 0 0 1 5 3h5V2q0-.424.287-.712A.97.97 0 0 1 11 1q.424 0 .713.288Q12 1.575 12 2v20q0 .424-.287.712A.97.97 0 0 1 11 23a.97.97 0 0 1-.713-.288A.97.97 0 0 1 10 22zm-5-3h5v-6zm9 3v-9l5 6V5h-5V3h5q.824 0 1.413.587Q21 4.176 21 5v14q0 .824-.587 1.413A1.93 1.93 0 0 1 19 21z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCompare);
export { ForwardRef as ReactComponent };